import { memo } from "react";
import Box from "@mui/material/Box";
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import { StepLabel, type StepLabelProps } from "ui/organizms/ECommerce/Onboarding/common";

const UploadDocumentsLabel = (props: Partial<StepLabelProps>) => (
    <StepLabel
        to={`${ECommerceOnboardingStep[ECommerceOnboarding.HighRiskMerchant].UploadDocuments}`}
        Icon={DocumentScannerIcon}
        endAdornment={(
            <Box
                component='ul'
                sx={{
                    gridColumn: '2'
                }}
            >
                {[
                    'Certificate of Incorporation',
                    'Memorandum',
                    'Articles of Association',
                    'Company Account Bank Statement',
                    'Copy of your licence',
                    'Bank reference',
                    'Proof of Domain Ownership',
                    'Passports of shareholders',
                    'Utility Bill of Shareholders'
                ].map((item, index) => (
                    <Box
                        component='li'
                        key={index}
                    >
                        {item}
                    </Box>
                ))}
            </Box>
        )}
        {...props}
        sx={{
            gridTemplateColumns: 'auto 1fr',
            ...props.sx
        }}
    >
        Upload Documents
    </StepLabel>
);

export default memo(UploadDocumentsLabel);
